import User from 'src/models/user'
import { UserClient } from 'src/api/Users'
import axios from 'axios'

export default {
  /**
   * Send a login request and redirect the user if the login was successful
   *
   * @param {string} email - User email
   * @param {string} password - User password
   * @param {string} otp - OTP token
   *
   * @returns {Promise}
   */
  login ({ email, password, otp }) {
    return axios.post('/authenticate', { email, password, otp })
      .then(response => this.parseAuthResponse(response))
  },

  /**
   * Get a new token using the refresh endpoint
   *
   * @returns {Promise}
   */
  refresh () {
    return axios.post('/refresh-token')
      .then(response => this.parseAuthResponse(response))
  },

  /**
   * Parse the login and refresh response
   *
   * @param response
   *
   * @returns {Promise}
   */
  parseAuthResponse (response) {
    let token = response.data.data.token

    let userData = response.data.data.user.data
    let user = new User(userData)
    let teams = userData.teams ? userData.teams.data : []
    let team = this.parseCurrentTeam(user, teams)
    let role = team ? team.role_id : null

    return Promise.resolve({
      token,
      user,
      teams,
      team,
      role
    })
  },

  /**
   * Fetch the user data and parse it
   *
   * @returns {Promise}
   */
  fetchUserData () {
    return new UserClient().include([
      'teams',
      'teams.settings',
      'teams.settings.default_email_address',
      'teams.settings.default_address',
      'teams.settings.default_phone_number',
      'teams.settings.default_bank_details',
      'teams.members',
      'teams.open_invites',
      'teams.subscription',
      'settings'
    ]).get()
      .then(response => {
        // User handling
        let userData = response.data.data
        let user = new User(userData)
        let teams = userData.teams ? userData.teams.data : []
        let team = this.parseCurrentTeam(user, teams)
        let role = team ? team.role_id : null

        return Promise.resolve({
          user,
          teams,
          team,
          role
        })
      })
  },

  /**
   * Parse the current team
   *
   * @param user
   * @param teams
   * @returns {*}
   */
  parseCurrentTeam (user, teams) {
    let team = null

    // No current team is set, but there exists teams
    // Choose first team
    if (!user.current_team_id && teams.length > 0) {
      team = teams[0]
      return team
    }

    team = teams.find(team => team.id === user.current_team_id)

    // Current team is set, but user is not part of the team
    if (!team && teams.length > 0) {
      team = teams[0]
      return team
    }

    return team || null
  }
}
